function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { math } from "noood/util/math/math";
import { _luminanceOf } from "noood/util/ui/color/computeLuminance";
import { _contrast } from "noood/util/ui/color/contrastBetween";
export var color = {
  adjustShade: function adjustShade(hexColor, percent) {
    // Remove the '#' if it exists
    hexColor = hexColor.replace('#', '');
    percent = percent * -1;

    // Convert hex to RGB
    var r = parseInt(hexColor.substring(0, 2), 16);
    var g = parseInt(hexColor.substring(2, 4), 16);
    var b = parseInt(hexColor.substring(4, 6), 16);

    // Adjust the RGB values based on the percentage
    r = Math.round(r * (1 + percent / 100));
    g = Math.round(g * (1 + percent / 100));
    b = Math.round(b * (1 + percent / 100));

    // Ensure the values stay within the 0-255 range
    r = Math.min(255, Math.max(0, r));
    g = Math.min(255, Math.max(0, g));
    b = Math.min(255, Math.max(0, b));

    // Convert the adjusted RGB values back to hex
    var toHex = function toHex(value) {
      var hex = value.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };
    return "#".concat(toHex(r)).concat(toHex(g)).concat(toHex(b));
  },
  determineCorrectTextContrast: function determineCorrectTextContrast(hexColor) {
    var bgLuminance = _luminanceOf(hexColor);
    var contrastWhite = _contrast(bgLuminance, _luminanceOf('#fefefe'));
    var contrastDarkGray = _contrast(bgLuminance, _luminanceOf('#525252'));
    return contrastWhite > contrastDarkGray ? '#fefefe' : '#333333';
  },
  determineCorrectTextScheme: function determineCorrectTextScheme(hexColor) {
    var bgLuminance = _luminanceOf(hexColor);
    var contrastWhite = _contrast(bgLuminance, _luminanceOf('#FFFFFF'));
    var contrastDarkGray = _contrast(bgLuminance, _luminanceOf('#333333'));
    return contrastWhite > contrastDarkGray ? 'light' : 'dark';
  },
  chooseCorrectForegroundColor: function chooseCorrectForegroundColor(_ref) {
    var backgroundHex = _ref.backgroundHex,
      foregroundHexLight = _ref.foregroundHexLight,
      foregroundHexDark = _ref.foregroundHexDark;
    var bgLuminance = _luminanceOf(backgroundHex);
    var contrastWhite = _contrast(bgLuminance, _luminanceOf(foregroundHexLight));
    var contrastDarkGray = _contrast(bgLuminance, _luminanceOf(foregroundHexDark));
    return contrastWhite > contrastDarkGray ? foregroundHexLight : foregroundHexDark;
  },
  extractCSSValue: function extractCSSValue(property) {
    var computedStyles = window.getComputedStyle(document.querySelector("body"));
    var extractedValue = computedStyles.getPropertyValue(property);
    return extractedValue;
  },
  adjustHue: function adjustHue(hex, percent) {
    function hexToHSL(hex) {
      var r = parseInt(hex.substring(0, 2), 16) / 255;
      var g = parseInt(hex.substring(2, 4), 16) / 255;
      var b = parseInt(hex.substring(4, 6), 16) / 255;
      var max = Math.max(r, g, b),
        min = Math.min(r, g, b);
      var h,
        s,
        l = (max + min) / 2;
      if (max === min) {
        h = s = 0; // achromatic
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }
        h /= 6;
      }
      return [h * 360, s, l];
    }
    function HSLToHex(h, s, l) {
      function hueToRGB(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      }
      h = h / 360;
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      var r = Math.round(hueToRGB(p, q, h + 1 / 3) * 255);
      var g = Math.round(hueToRGB(p, q, h) * 255);
      var b = Math.round(hueToRGB(p, q, h - 1 / 3) * 255);
      return "#".concat(r.toString(16).padStart(2, '0')).concat(g.toString(16).padStart(2, '0')).concat(b.toString(16).padStart(2, '0'));
    }
    var _hexToHSL = hexToHSL(hex.replace("#", "")),
      _hexToHSL2 = _slicedToArray(_hexToHSL, 3),
      h = _hexToHSL2[0],
      s = _hexToHSL2[1],
      l = _hexToHSL2[2];
    h = (h + percent / 100 * 360) % 360;
    return HSLToHex(h, s, l);
  },
  appendAlpha: function appendAlpha(color, percent) {
    if (!color.startsWith('#')) {
      color = '#' + color;
    }
    return color.concat(Math.floor(255 * (percent / 100)).toString(16));
  },
  getComplementaryColor: function getComplementaryColor(hex) {
    // Remove leading '#' if present
    hex = hex.replace(/^#/, '');

    // Ensure valid 6-digit hex
    if (!/^[0-9A-Fa-f]{6}$/.test(hex)) {
      throw new Error("Invalid hex color format");
    }

    // Convert to RGB and compute complement
    var r = 255 - parseInt(hex.slice(0, 2), 16);
    var g = 255 - parseInt(hex.slice(2, 4), 16);
    var b = 255 - parseInt(hex.slice(4, 6), 16);

    // Convert back to hex with padding
    var compHex = [r, g, b].map(function (val) {
      return val.toString(16).padStart(2, '0');
    }).join('');
    return "#".concat(compHex);
  }
};